@let collapsed = viewModel.collapsed$ | push;

<div class="side-nav-bar" [class.collapsed]="collapsed">
  <app-side-nav-header [style.margin-bottom.rem]="2" (toggleCollapsed)="viewModel.toggleCollapsed()" />
  <app-side-nav-body [collapsed]="collapsed" (expandSideNav)="viewModel.connectToCollapsed(false)" />
  <app-side-nav-footer />
</div>
